/**
 * Result of checking the current notification permission state.
 * Used to determine whether to show the pre-permission modal.
 */
export enum NotificationPermissionState {
  /** Permission has never been requested — show the pre-permission modal */
  PROMPT = 'PROMPT',
  /** Permission already granted — proceed with FCM initialization directly */
  PROCEED = 'PROCEED',
  /** Permission explicitly denied by user — show weekly reminder */
  DENIED = 'DENIED',
  /** Notifications unavailable (unsupported browser or missing config) */
  UNAVAILABLE = 'UNAVAILABLE',
}
